import ENV from "../env";

async function inventoryCountStockItem({ stockItemId, countedValue, venueId, createdBy }) {
  const response = await fetch(`${ENV.firebaseApiUrl}/stock/inventory-count`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      stockItemId,
      countedValue,
      venueId,
      createdBy,
    }),
  });

  const data = await response.json();
  if (!response.ok) throw new Error(data?.error || "Inventory count failed");
}

export default inventoryCountStockItem;
